import builder from '../../api/builder'
import * as types from './types'

const Promise = window.Promise || require('promise')

export const triggerReplyComment = ({ commit, getters, state }, payload) => {
  commit(types.TRIGGER_REPLY_COMMENT, payload)
}

export const submitComment = ({ commit, getters, rootState }, payload) => {
  let token
  if (rootState.users.token !== 'undefined' &&
    rootState.users.token !== ''
  ) {
    token = rootState.users.token
  }
  return builder.submitComment(token, {
    contestId: getters.getBuilder.contestId,
    contestContentId: getters.getBuilder.contestContentId,
    cxid: getters.getBuilder.contestContentId,
    parent: payload.parent,
    private: payload.private,
    content: payload.content,
    commentRecaptcha: payload.commentRecaptcha
  }).then(data => {
    if (data.results.status === 'published') {
      commit(types.MERGE_NEW_COMMENT, {
        comment: data.results,
        cxid: getters.getBuilder.contestContentId,
        parent: payload.parent,
        private: payload.private
      })
    }
    return Promise.resolve(data.results)
  }, err => {
    return Promise.reject(err)
  })
}

export const fetchComments = ({ commit, getters, rootState }, payload) => {
  let token
  if (rootState.users.token !== 'undefined' &&
    rootState.users.token !== ''
  ) {
    token = rootState.users.token
  }
  return builder.getComments(token, {
    contestId: getters.getBuilder.contestId,
    contestContentId: getters.getBuilder.contestContentId,
    page: payload.page,
    limit: payload.limit || 10,
    parent: payload.parent,
    loadMore: payload.loadMore,
    comment: payload.comment || 0,
    isHighlightComment: payload.isHighlightComment || false
  }).then(res => {
    if (payload.isHighlightComment === true) {
      commit(types.HIGHLIGHT_COMMENT, {
        appendSubComments: res.results
      })
    } else {
      commit(types.COMMENTS, {
        parent: payload.parent,
        comments: res.results,
        loadMore: payload.loadMore
      })
    }
    if (typeof payload.isHighlightComment === 'undefined' ||
      payload.isHighlightComment === true
    ) {
      if (Object.keys(res.highlightComment).length > 0) {
        commit(types.HIGHLIGHT_COMMENT, res.highlightComment)
      }
    }
    return Promise.resolve(res)
  }, err => {
    return Promise.reject(err)
  })
}

export const fetchBuilder = ({ commit, rootState }, payload = { locale: 'tw', alias: '' }) => {
  let token
  if (rootState.users.token !== 'undefined' &&
    rootState.users.token !== ''
  ) {
    token = rootState.users.token
  }
  return builder.get(token, payload.locale, payload.alias)
    .then(data => {
      commit(types.DATA, data.results)
      return Promise.resolve(data.results)
    }, err => {
      commit(types.DATA, {})
      return Promise.reject(err)
    })
}




// WEBPACK FOOTER //
// ./src/vuex/builder/actions.js